import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import Gallery from 'components/common/Gallery';
import './GiveAwayDetails.scss';
import './MiniPricingPlan.scss';
// TODO: REVISIT LICENSE: https://www.svgrepo.com/
import engine from '../../../../assets/images/engine.svg';
import allWheelDrive from '../../../../assets/images/all-wheel-drive.svg';
import gearStick from '../../../../assets/images/gear-stick.svg';
import speedometer from '../../../../assets/images/speedometer.svg';
import rimTyre from '../../../../assets/images/rim-tyre.svg';
import carKey from '../../../../assets/images/car-key.svg';
import Listicon from '../../../../assets/images/listicon.svg';
import { YoutubeVideoPlayer } from '../../../common/YoutubeVideoPlayer';
import * as giveawayApis from 'apis/giveaways';
;

const MiniPricingPlan = () => {
    const [plan, setPlan] = useState('vip');

    return (
        <div className="mini-pricing-plan">

            <div className="row btn-holder">
                <button onClick={() => setPlan('vip')} className={`btn-plan ff-inter-semibold ${plan === 'vip' ? 'active' : ''}`}>
                    <div className="mb-50 fs-200">₹1899</div>
                    <span className="fs-150">VIP</span>
                </button>
                <button onClick={() => setPlan('basic')} className={`btn-plan ff-inter-semibold ${plan === 'basic' ? 'active' : ''}`}>
                    <div className="mb-50 fs-200">₹99</div>
                    <span className="fs-150">Basic</span>
                </button>
                <button onClick={() => setPlan('standard')} className={`btn-plan ff-inter-semibold ${plan === 'standard' ? 'active' : ''}`}>
                    <div className="mb-50 fs-200">₹149</div>
                    <span className="fs-150">Standard</span>
                </button>
                <button onClick={() => setPlan('premium')} className={`btn-plan ff-inter-semibold ${plan === 'premium' ? 'active' : ''}`}>
                    <div className="mb-50 fs-200">₹459</div>
                    <span className="fs-150">Premium</span>
                </button>
            </div>

            <div className="features-holder">
                {plan === 'vip' && (
                    <div className="pt-200">
                        <strong className="fs-200 d-block text-left ff-inter-bold">20 Free entries</strong>

                        <ul className='list-reset features fs-150 ff-inter-light lh-200 mt-200 mb-300'>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" /> Get 20 accumulating entry if membership continues </li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  Free access to events</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  Free drinks or food vouchers on all events</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  Free Tyren Customs T-shirt</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  Member exclusive savings from partner businesses or shops</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />  Cancel Anytime</li>
                        </ul>

                        <a className="btn-primary" href="javascript:;">Subscribe Now</a>
                    </div>
                )}

                {plan === 'basic' && (
                    <div className="pt-200">
                        <strong className="fs-200 d-block text-left ff-inter-bold">1 Free entry</strong>

                        <ul className='list-reset features fs-150 ff-inter-light lh-200 mt-200 mb-300'>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" /> Get 1 accumulating entry if membership continues </li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" /> Member exclusive savings from partner businesses or shops</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" /> Discounted or free access to events</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" /> Cancel Anytime</li>
                        </ul>

                        <a className="btn-primary" href="javascript:;">Subscribe Now</a>
                    </div>
                )}

                {plan === 'standard' && (
                    <div className="pt-200">
                        <strong className="fs-200 d-block text-left ff-inter-bold">3 Free entries</strong>

                        <ul className='list-reset features fs-150 ff-inter-light lh-200 mt-200 mb-300'>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Get 3 accumulating entry if membership continues</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Member exclusive savings from partner businesses or shops</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Discounted or free access to events</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Cancel Anytime</li>
                        </ul>

                        <a className="btn-primary" href="javascript:;">Subscribe Now</a>
                    </div>
                )}

                {plan === 'premium' && (
                    <div className="pt-200">
                        <strong className="fs-200 d-block text-left ff-inter-bold">5 Free entries</strong>

                        <ul className='list-reset features fs-150 ff-inter-light lh-200 mt-200 mb-300'>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Get 5 accumulating entry if membership continues</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Member exclusive savings from partner businesses or shops</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Discounted or free access to events</li>
                            <li className="pl-300 relative mb-100"> <img src={Listicon} className="s-200 absolute l-0 t-0" alt="" />Cancel Anytime</li>
                        </ul>

                        <a className="btn-primary" href="javascript:;">Subscribe Now</a>
                    </div>
                )}
            </div>

        </div>
    );
};

const GiveAwayCard = () => {
    const assetUrl = process.env.REACT_APP_TAURIAN_ASSET_URL;
    const { id } = useParams();
    const [giveaway, setGiveaway] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await giveawayApis.fetchGiveaway(id);
        setGiveaway(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const iconMap = {
    'carKey': carKey,
    'engine': engine,
    'rimTyre':rimTyre,
    'allWheelDrive':allWheelDrive,
    'gearStick':gearStick,
    'speedometer':speedometer
};

  const formatDate = (date,secondFormat=false) => {
    const months = [
        'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
        'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER',
    ];

    const suffixes = ['TH', 'ST', 'ND', 'RD'];
    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return 'TH';
        switch (day % 10) {
            case 1: return 'ST';
            case 2: return 'ND';
            case 3: return 'RD';
            default: return 'TH';
        }
    };

    const day = date.getDate();
    const month = months[date.getMonth()];
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const year = date.getFullYear();

    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = String(minutes).padStart(2, '0'); // Pad minutes
    if(secondFormat){
        return (
            <>
            {`${day}${getDaySuffix(day).toLowerCase()} of ${month},${year}`} 
            
            </>
        )
    }
    else
    return (
        <>
            {`${day}${getDaySuffix(day)} ${month}`} <br />
            {`${formattedHours}:${formattedMinutes}${ampm}`}
        </>
    );
    };
    function getYouTubeVideoId(url) {
        if(!url) return null;
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    return (
        <div className="container mt-300">

            <div className="row mb-300">
                <div className="col-12 col-md-7 pr-md-300">

                    <div className="mb-300">
                        <Gallery images={giveaway?.images}/>
                    </div>

                    <div className="d-md-none">
                        <div className="row fs-200 ff-inter-semibold m-none mb-200">

                            <div className="col-6 col-sm-6">
                                <div className="fs-200 ff-inter-light">Entries close on</div>
                                {formatDate(new Date(giveaway?.endDate))}
                                <div className="fs-150 fs-italic ff-inter-light">Indian Standard Time</div>
                            </div>

                            <div className="col-6 col-sm-6">
                                <div className="fs-200 ff-inter-light">Drawing on</div>
                                {formatDate(new Date(giveaway?.drawDate))}
                                
                                <div className="fs-150 fs-italic ff-inter-light">Indian Standard Time</div>
                            </div>


                        </div>

                        <div className="border my-200"></div>

                        <MiniPricingPlan />

                        <div className="border my-200"></div>

                        <div className="mb-200">
                            <div className="fs-200 ff-inter-medium mb-100">Entry info:</div>
                            <ul className="pl-200 fs-150 ff-inter-light">
                                <li className="mb-100">Valid to all Indians or residents in India.</li>

                                <li className="mb-100">Existing members are automatically entered in the draw.</li>

                                <li className="mb-100">Will be shipped to winner from any state or pick up from our showroom.</li>

                                <li className="mb-100">Delivery of the item to the winner within 28 business days of the draw date.</li>

                                <li className="mb-100">Entries will close on 15th of September 2024 at midnight.</li>

                                <li className="mb-100">The Draw will be held on the 16th of September 2024 at our office.</li>

                                <li className="mb-100">Winner selection will be live streamed via our Facebook and the winner will be contacted immediately.</li>

                                <li className="mb-100">Become a member of Taurian and receive entries into this trade promotional draw.</li>
                            </ul>
                        </div>

                        <div className="border my-200"></div>
                    </div>

                    <div className="fs-200 ff-inter-medium mb-100">Description:</div>

                    <div className="fs-200 mb-300 ff-inter-light">
                        {giveaway.description}
                    </div>

                    <div className="fs-200 ff-inter-medium mb-100">Key Specs:</div>

                    <ul className="pl-300 pr-300  fs-150 ff-inter-light">
                        {
                            giveaway?.descriptionList?.map((description)=>{
                                return(
                                    <li className="mb-100">{description}</li>
                                )
                            })
                        }
                        

                    </ul>

                    <div className="highlights flex flex-wrap mt-400 mb-400 ">
                        {
                            giveaway?.attributes?.map((attribute) =>{
                                return (
                                    <div className="text-center spec mb-400">
                                    <img className="s-300" src={ iconMap[attribute?.logo]} />
                                    <div className="mt-50 fs-150 ff-inter-light">{attribute?.text}</div>
                                </div>
                                )

                            })
                        }
                       

                       

                    </div>

                    <a className="learn-more-link ff-inter-medium ff-inter-medium" href={giveaway?.productLink} target="_blank" 
            rel="noopener noreferrer">Learn more about this product</a>

                    <div className="my-200">

                        <YoutubeVideoPlayer embedId={getYouTubeVideoId(giveaway?.youtubeLink)} />

                    </div>



                    

                    <div className="mb-300"></div>

                </div>

                <div className="d-none d-md-block col-md-5">


                    <div className="row fs-200 ff-inter-semibold m-none mb-200">

                        <div className="col-md-6">
                            <div className="fs-200 ff-inter-light">Entries close on</div>
                            {formatDate(new Date(giveaway?.endDate))}
                            <div className="fs-150 fs-italic ff-inter-light">Indian Standard Time</div>
                        </div>

                        <div className="col-md-6">
                            <div className="fs-200 ff-inter-light">Drawing on</div>
                            {formatDate(new Date(giveaway?.drawDate))}
                            <div className="fs-150 fs-italic ff-inter-light">Indian Standard Time</div>
                        </div>

                    </div>

                    <div className="border my-200"></div>

                    <MiniPricingPlan />

                    <div className="border my-200"></div>

                    <div className="mb-200">
                        <div className="fs-200 ff-inter-medium mb-100">Entry info:</div>
                        <ul className="pl-200 fs-150 ff-inter-light">
                            <li className="mb-100">Valid to all Indians or residents in India.</li>

                            <li className="mb-100">Existing members are automatically entered in the draw.</li>

                            <li className="mb-100">Will be shipped to winner from any state or pick up from our showroom.</li>

                            <li className="mb-100">Delivery of the item to the winner within 28 business days of the draw date.</li>

                            <li className="mb-100">Entries will close on {formatDate(new Date(giveaway?.endDate),true)} at midnight.</li>

                            <li className="mb-100">The Draw will be held on the {formatDate(new Date(giveaway?.drawDate),true)} at our office.</li>

                            <li className="mb-100">Winner selection will be live streamed via our Facebook and the winner will be contacted immediately.</li>

                            <li className="mb-100">Become a member of Taurian and receive entries into this trade promotional draw.</li>
                        </ul>
                    </div>





                </div>
            </div>

        </div>
    );
};

export default GiveAwayCard;
